import { render, staticRenderFns } from "./food.vue?vue&type=template&id=518ea29e"
import script from "./food.vue?vue&type=script&lang=js"
export * from "./food.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports